var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00028 8.00003L3.33362 8.00003M3.27718 8.19436L1.72057 12.8442C1.59828 13.2095 1.53713 13.3921 1.58101 13.5046C1.61912 13.6023 1.70096 13.6763 1.80195 13.7045C1.91824 13.7369 2.09388 13.6579 2.44517 13.4998L13.5862 8.48639C13.929 8.33209 14.1005 8.25494 14.1535 8.14777C14.1995 8.05466 14.1995 7.94541 14.1535 7.85229C14.1005 7.74512 13.929 7.66797 13.5861 7.51367L2.44129 2.49851C2.09106 2.34091 1.91595 2.26211 1.79977 2.29443C1.69888 2.32251 1.61704 2.39636 1.57881 2.49386C1.53478 2.60612 1.59527 2.78837 1.71625 3.15288L3.27761 7.85705C3.29839 7.91965 3.30878 7.95095 3.31288 7.98297C3.31652 8.01138 3.31649 8.04013 3.31277 8.06853C3.30859 8.10054 3.29812 8.13181 3.27718 8.19436Z",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d140de97dd67b8905fc76f4c8945642c.svg";
export { ForwardRef as ReactComponent };